import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-camera-small',
  templateUrl: './icon-camera-small.component.html',
  styles: []
})
export class IconCameraSmallComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
